import React from "react";
import { Brand } from "./Brand";
import { FeedbackLink } from "./FeedbackLink";

export function Header({ theme, onToggleTheme, onNavigate }) {
  return (
    <header className="site-header">
      <button className="brand-button" type="button" onClick={() => onNavigate("/")} aria-label="TheoFast home">
        <Brand />
      </button>
      <nav className="header-actions" aria-label="Primary navigation">
        <FeedbackLink compact />
        <button className="icon-button theme-toggle" type="button" onClick={onToggleTheme} aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}>
          {theme === "dark" ? (
            <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" /></svg>
          ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21 12.7A9 9 0 1 1 11.3 3 7 7 0 0 0 21 12.7Z" /></svg>
          )}
        </button>
      </nav>
    </header>
  );
}
